import { reactive } from 'vue';

export const activeComponentStore = reactive({
    activeComponents: {},

    // Register component with the events it listens to and its refresh callback
    registerComponent(name, events, refreshCallback) {
        this.activeComponents[name] = { events, refreshCallback };
    },

    // Deregister component
    deregisterComponent(name) {
        delete this.activeComponents[name];
    },

    // // Notify components listening to a specific event, except the origin. The component that called can be excluded.
    // notifyComponents(event, origin) {
    //     Object.entries(this.activeComponents).forEach(([componentName, { events, refreshCallback }]) => {
    //         if (componentName !== origin && events.includes(event)) {
    //             if (typeof refreshCallback === 'function') {
    //                 refreshCallback(event);  // Pass the event type to the callback if needed
    //             }
    //         }
    //     });
    // },

    // Notify components listening for a specific event, except the origin. The component that called can be excluded.
    // A list of events can be passed in to prevent multiple executions of the listening component's callback.
    notifyComponents(eventList, origin) {
        Object.entries(this.activeComponents).forEach(([componentName, { events, refreshCallback }]) => {
            if (componentName !== origin && events.some(eventName => eventList.includes(eventName))) {
                if (typeof refreshCallback === 'function') {
                    refreshCallback();
                }
            }
        });
    }
})